import { sortBy } from 'lodash'

import ApiHandler from '@/api/base'
import { GLOBAL_GROUP_KEYS } from '@/utils/global-groups'

class HomepageGroupsApiHandler extends ApiHandler {
  async getGroupsForFilter(groupId) {
    const { data } = await this.http.get('/homepage/groupsForFilter', {
      params: {
        groupId
      }
    })

    return data
  }

  async getNestedGroupsForFilter(parentId) {
    const { data } = await this.http.get('/homepage/nestedGroups', {
      params: {
        parentId
      }
    })

    return data
  }

  async searchGroups({ searchString = null, ids = [] } = {}) {
    const { data } = await this.http.post('/homepage/groups', {
      searchString,
      ids: searchString ? null : ids
    })

    return data
  }

  // only the requested groups are kept, and the pinned order saved by the user is restored,
  // because the backend returns its own order
  async getPinnedGroupsData(groupIds = []) {
    const data = await this.searchGroups({ ids: groupIds })

    const groups = data.groups.filter(group => groupIds.includes(group[GLOBAL_GROUP_KEYS.ID]))

    return {
      ...data,
      groups: sortBy(groups, group => groupIds.indexOf(group[GLOBAL_GROUP_KEYS.ID]))
    }
  }

  // the response may contain more than the requested ids, so the group is matched by id
  async isGroupExists(groupId) {
    const { groups } = await this.searchGroups({ ids: [groupId] })

    return (groups ?? []).some(group => group[GLOBAL_GROUP_KEYS.ID] === groupId)
  }

  async getFirstAvailableGroup() {
    const { data } = await this.http.get('/homepage/groupsForFilter', {
      params: {
        groupId: null,
        startAt: 0,
        limit: 1
      }
    })

    const [firstGroup = null] = data.groups

    return firstGroup
  }

  async getGroupsByName(searchString = null) {
    return await this.searchGroups({ searchString })
  }

  async getGroupById(groupId) {
    const { groups } = await this.getPinnedGroupsData([groupId])

    return groups.at(0)
  }
}

export default HomepageGroupsApiHandler
